import {Signal, signal, WritableSignal} from "@angular/core";

export class SignalModel<T> {
    get value(): T {
        return this._signal();
    }

    set value(value: T) {
        this._signal?.set(value)
    }

    readonly _signal!: WritableSignal<T>

    get signal(): Signal<T> {
        return this._signal;
    }

    constructor(value: T) {
        this._signal = signal(value)
    }

    toJson() {
        return this.value;
    }
}
